import { func, object, type, optional, boolean } from 'superstruct';

export const liveChatConfigSchema = object({
  liveChatClient: type({
    handleUserChatEvents: func(),
    subscribeToAgentChatEvents: func(),
  }),
  shouldShowNavigateAway: optional(boolean()),
});
